<template>
  <div class="p-fluid p-grid">
    <div class="p-col-12">
      <div class="box-group-function">
        <div class="group-title">Thông tin công ty</div>
        <span class="p-input-icon-left">
          <Button
            :disabled="disabled"
           :label="'Cập nhật'"
            type="button"
            class="p-button-success custom-button-update"
            @click="saveData()"
          > </Button>
        </span>
        <div class="p-field p-grid p-group-sms">
          <label class="p-col-fixed p-col-3" >Hotline hỗ trợ khách hàng</label>
          <div class="p-col">
            <InputText id="hotline" class="hotline" type="text" v-model="hotline" maxlength="255" @keyup="change_data" />
          </div>
        </div>
      </div>

      <div class="box-group-function">
        <div class="group-title">Phân quyền dữ liệu Mobile App</div>
        <div class="group-input">
          <InputSwitch v-model="setting_unit_view" @change="change_data" />
          <label>Xem dữ liệu theo đơn vị</label>
        </div>
      </div>
      <div class="box-group-function">
        <div class="group-title">Hiệu lực mã xác thực OTP</div>
        <div class="p-field p-grid p-group-sms">
          <label for="sms_expired_time" class="p-col-fixed p-col-3" >Thời gian hiệu lực mã OTP</label>
          <div class="p-col">
            <InputMask  v-model="sms_expired_time" mask="99:99" class="input-time" @keyup="change_data" />
            <span>giây</span>
          </div>
        </div>
        <small v-if="check_expired"
                        class="p-invalid" >Thời gian hiệu lực mã OTP không hợp lệ</small>
        <div class="p-field p-grid p-group-sms">
          <label for="sms_warning_time" class="p-col-fixed p-col-3" >Thời gian sắp hết hiệu lực OTP</label>
          <div class="p-col">
            <InputMask  v-model="sms_warning_time" mask="99:99" class="input-time" @keyup="change_data" />
            <span>giây</span>
          </div>
        </div>
        <small v-if="check_warning"
                        class="p-invalid" >Thời gian sắp hết hiệu lực OTP không hợp lệ</small>
      </div>
      <div class="box-group-function">
        <div class="group-title">Cấu hình kích hoạt bảo hành</div>
        <div class="group-input">
          <InputSwitch v-model="required_upload_image_invoice" @change="change_data" />
          <label>Bắt buộc upload ảnh hóa đơn</label>
        </div>
        <div class="group-input">
          <InputSwitch v-model="required_upload_image_contract" @change="change_data" />
          <label>Bắt buộc upload ảnh biên bản nghiệm thu</label>
        </div>
      </div>
      <div class="box-group-function">
        <div class="group-title">Thông tin email gửi thông báo</div>
        <div class="p-field p-col-3">
        <!--<div class="p-col-8">-->
          <label for="email">Tài khoản email</label>
          <InputText  id="email" type="text" v-model="email" @keyup="change_data"/>
          <small v-if="validationErrors && validationErrors['email']"
                 class="p-invalid" >{{validationErrors['email']}}</small>
        <!--</div>-->
      </div>
        <div class="p-field p-col-3">
          <!--<div class="p-col-8">-->
            <label for="email">Mật khẩu</label>
            <InputText  id="password" type="password" v-model="password" @keyup="change_data"/>
          <!--</div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
export default {
  data() {
    return {
      validationErrors: {},
      setting_unit_view: true,
      required_upload_image_invoice: false,
      required_upload_image_contract: false,
      sms_warning_time: 0,
      sms_expired_time: 0,
      componentKey: 0,
      check_warning: false,
      check_expired: false,
      hotline: '',
      email:'',
      password:'',
      disabled:true,
      data_old:{
        hotline:'',
        setting_unit_view:true,
        sms_expired_time:0,
        sms_warning_time:0,
        required_upload_image_invoice:false,
        required_upload_image_contract:false,
        email:'',
        password:'',
      }
    }
  },
  mounted () {
    this.initParams();
  },
  created () {
    if(this.$route.params.reload) {
      window.location.reload();
    }
  },
  watch: {
    '$route': 'initParams'
  },
  methods: {
    change_data(){
      if (this.data_old.hotline != this.hotline
          || this.data_old.setting_unit_view != this.setting_unit_view
          || this.data_old.sms_expired_time != this.sms_expired_time
          || this.data_old.sms_warning_time != this.sms_warning_time
          || this.data_old.required_upload_image_invoice != this.required_upload_image_invoice
          || this.data_old.required_upload_image_contract != this.required_upload_image_contract
          || this.data_old.email != this.email
          || this.data_old.password != this.password
      ){
        this.disabled = false;
      }else {
        this.disabled =true;
      }
    }
    ,
    async initParams() {
      this.modelName = 'settings';
      var variables = {
        where_key: {
          key: {'_in': ['SMS_WARNING_TIME', 'SMS_EXPIRED_TIME', 'SETTING_UNIT_VIEW', 'REQUIRED_UPLOAD_IMAGE_INVOICE', 'REQUIRED_UPLOAD_IMAGE_CONTRACT', 'QR_SERIAL_NUMBER_HOTLINE','CF_EMAIL_SEND'] }
        }
      }
      var data = await DataServices.getList(this.modelName, {"variables": JSON.stringify(variables), "fields": 'key, value'});
      var list = data[Object.keys(data)];
      if (list != undefined && list != null) {
        var obj_sms_warning_time = list.find(o => o.key === 'SMS_WARNING_TIME');
        var obj_sms_expired_time = list.find(o => o.key === 'SMS_EXPIRED_TIME');
        var obj_setting_unit_view = list.find(o => o.key === 'SETTING_UNIT_VIEW');
        var obj_required_upload_image_invoice = list.find(o => o.key === 'REQUIRED_UPLOAD_IMAGE_INVOICE');
        var obj_required_upload_image_contract = list.find(o => o.key === 'REQUIRED_UPLOAD_IMAGE_CONTRACT');
        
        var obj_qr_code = list.find(o => o.key === 'QR_SERIAL_NUMBER_HOTLINE');
        var obj_email = list.find(o => o.key === 'CF_EMAIL_SEND');

        if (obj_setting_unit_view != null && Object.keys(obj_setting_unit_view).length > 0) {
          this.setting_unit_view = JSON.parse(obj_setting_unit_view.value);
          this.data_old.setting_unit_view = JSON.parse(obj_setting_unit_view.value);
        }
        if (obj_required_upload_image_invoice != null && Object.keys(obj_required_upload_image_invoice).length > 0) {
          this.required_upload_image_invoice = JSON.parse(obj_required_upload_image_invoice.value);
          this.data_old.required_upload_image_invoice = JSON.parse(obj_required_upload_image_invoice.value);
        }
        if (obj_required_upload_image_contract != null && Object.keys(obj_required_upload_image_contract).length > 0) {
          this.required_upload_image_contract = JSON.parse(obj_required_upload_image_contract.value);
          this.data_old.required_upload_image_contract = JSON.parse(obj_required_upload_image_contract.value);
        }

        if (obj_sms_warning_time != null && Object.keys(obj_sms_warning_time).length > 0) {
          this.sms_warning_time = this.$myConstants.convertNumberToMinutesSecond(parseInt(obj_sms_warning_time.value));
          this.data_old.sms_warning_time = this.$myConstants.convertNumberToMinutesSecond(parseInt(obj_sms_warning_time.value));
        }
        if (obj_sms_expired_time != null && Object.keys(obj_sms_expired_time).length > 0) {
          this.sms_expired_time = this.$myConstants.convertNumberToMinutesSecond(parseInt(obj_sms_expired_time.value));
          this.data_old.sms_expired_time = this.$myConstants.convertNumberToMinutesSecond(parseInt(obj_sms_expired_time.value));
        }
        if (obj_qr_code != null && Object.keys(obj_qr_code).length > 0) {
          this.hotline = obj_qr_code.value;
          this.data_old.hotline = obj_qr_code.value;
        }
        if (obj_email != null && Object.keys(obj_email).length > 0) {
          this.email = obj_email.value;
          this.data_old.email = obj_email.value;
        }


        
      }
      this.componentKey++;
    },
    async validationData() {
      this.validationErrors = {};
      var email = (!this.$myConstants.isEmpty(this.email)) ? this.email:'';
      if (this.$myConstants.isEmpty(email)){
        this.validationErrors['email'] = 'Nhập email';
      }
      if (!(Object.entries(this.validationErrors).length === 0)) {
        //Nếu tồn tại lỗi thì force để load validator mượt
        this.$forceUpdate();
      }
    },
    
    async saveData() {
      this.check_warning = await this.$myConstants.checkInputTime(this.sms_warning_time);
      this.check_expired = await this.$myConstants.checkInputTime(this.sms_expired_time);
      var email = (!this.$myConstants.isEmpty(this.email)) ? this.email:'';
      var password = (!this.$myConstants.isEmpty(this.password)) ? this.password:'';
      await this.validationData();
      if ( Object.entries(this.validationErrors).length === 0) {
      if (!this.check_warning && !this.check_expired) {
        var seconds_warning = this.$myConstants.convertMinutesSecondToNumber(this.sms_warning_time);
        var seconds_expired = this.$myConstants.convertMinutesSecondToNumber(this.sms_expired_time);

        await DataServices.updateData(this.modelName, {
          "variables": JSON.stringify({
            data_update: {value: this.setting_unit_view.toString()},
            where_key: {key: {'_eq': 'SETTING_UNIT_VIEW'}}
          })
        });
        await DataServices.updateData(this.modelName, {
          "variables": JSON.stringify({
            data_update: {value: seconds_warning.toString()},
            where_key: {key: {'_eq': 'SMS_WARNING_TIME'}}
          })
        });
        await DataServices.updateData(this.modelName, {
          "variables": JSON.stringify({
            data_update: {value: seconds_expired.toString()},
            where_key: {key: {'_eq': 'SMS_EXPIRED_TIME'}}
          })
        });
        await DataServices.updateData(this.modelName, {
          "variables": JSON.stringify({
            data_update: {value: this.required_upload_image_invoice.toString()},
            where_key: {key: {'_eq': 'REQUIRED_UPLOAD_IMAGE_INVOICE'}}
          })
        });
        await DataServices.updateData(this.modelName, {
          "variables": JSON.stringify({
            data_update: {value: this.required_upload_image_contract.toString()},
            where_key: {key: {'_eq': 'REQUIRED_UPLOAD_IMAGE_CONTRACT'}}
          })
        });
        await DataServices.updateData(this.modelName, {
          "variables": JSON.stringify({
            data_update: {value: this.hotline.toString()},
            where_key: {key: {'_eq': 'QR_SERIAL_NUMBER_HOTLINE'}}
          })
        });

        await this.$coreService.callApiPost('/common/update_info_email', {email: email, password_email: password}, {})
        //set data old
        this.data_old.hotline = this.hotline;
        this.data_old.setting_unit_view = this.setting_unit_view;
        this.data_old.sms_expired_time = this.sms_expired_time;
        this.data_old.sms_warning_time = this.sms_warning_time;
        this.data_old.required_upload_image_invoice = this.required_upload_image_invoice;
        this.data_old.required_upload_image_contract = this.required_upload_image_contract;
        this.data_old.email = this.email;
        this.data_old.password = '';
        this.password = '';
        this.disabled = true;
        this.$toast.add({severity: 'success', summary: 'Thông báo', detail: 'Cập nhật thành công', life: 3000})
        this.componentKey++;
      }
      }

    },
    refreshData(){
      this.initParams();
    }
  }
}
</script>
<style lang="scss">
.box-group-function{margin-bottom: 10px; position: relative;
  &:last-child{margin-bottom: 0;}
  .group-title{font-size: 14px; font-weight: bold;}
  .p-input-icon-left{position: relative; float: right; top: -15px;}
  .group-input{ display: flex; margin-top: 10px; margin-left: 10px;
    label{margin-bottom: 0; margin-left: 10px;}
  }
  .p-group-sms{ margin-top: 10px;
    label{margin: 0; padding: 0 0 0 20px;}
    .p-col{ padding: 0; margin-left: 10px;
      .input-time{width: 60px; height: 30px; margin-right: 10px;}
      .hotline{width: 150px; text-align: right;}
    }
  }
  small{padding-left: 12px;}
}
</style>